export const Digits5Schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "legalName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/wp-content/uploads/logo.png"
      },
      "description": "تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران؛ ارائه‌دهنده مرکز تلفن ابری، CRM ابری، خط تلفن اینترنتی، پنل پیامکی، فکس آنلاین و خطوط ویژه مخابراتی.",
      "sameAs": [
        "https://www.linkedin.com/company/mynavatel",
        "https://www.instagram.com/navatel.ir",
        "https://www.threads.com/@navatel.ir"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+98-21-82800000",
        "areaServed": "IR",
        "availableLanguage": ["fa"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/5-digit-line/#webpage",
      "url": "https://navatel.ir/products/5-digit-line/",
      "name": "خط تلفن ۵ رقمی مخابرات | شماره کوتاه با هزینه بهینه برای کسب‌وکار",
      "description": "خط تلفن ۵ رقمی مخابرات نواتل، تعادل ایده‌آل بین اعتبار سازمانی و هزینه است؛ شماره‌ای کوتاه، در دسترس‌تر و مقرون‌به‌صرفه‌تر نسبت به خط ۴ رقمی، مناسب کسب‌وکارهای در حال رشد. فروش و تحویل فوری حتی در ایام تعطیل.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/products/5-digit-line/#service"
      },
      "inLanguage": "fa-IR",
      "breadcrumb": {
        "@id": "https://navatel.ir/products/5-digit-line/#breadcrumb"
      }
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/5-digit-line/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "خط تلفن ۵ رقمی مخابرات",
          "item": "https://navatel.ir/products/5-digit-line/"
        }
      ]
    },
    {
      "@type": "Service",
      "@id": "https://navatel.ir/products/5-digit-line/#service",
      "name": "خط تلفن ۵ رقمی مخابرات نواتل",
      "alternateName": "شماره تماس اختصاصی ۵ رقمی سازمانی",
      "serviceType": "خط تلفن اختصاصی ۵ رقمی مخابرات (وساطت خرید از مخابرات ایران)",
      "description": "خط تلفن ۵ رقمی مخابرات، گزینه‌ای هوشمندانه برای سازمان‌هایی است که می‌خواهند شماره کوتاه و حرفه‌ای داشته باشند اما بودجه خط ۴ رقمی را ندارند. نسبت به خط ۴ رقمی مقرون‌به‌صرفه‌تر است و شماره‌های ۵ رقمی بیشتر از خط ۴ رقمی موجود و در دسترس هستند. نواتل به‌عنوان واسطه، فرآیند ثبت، تأیید مدارک از مخابرات ایران و تحویل این خطوط را انجام می‌دهد؛ با امکان تحویل فوری حتی در ایام تعطیل. این خطوط استانی بوده و در حال حاضر تنها با پیش‌شماره ۰۲۱ (تهران) ارائه می‌شوند؛ به این معنا که خط به شبکه تلفن ثابت تهران متصل است و تماس‌گیرندگان از سایر استان‌ها با آن تماس بین‌شهری برقرار می‌کنند. این سرویس مختص اشخاص حقوقی (شرکت‌ها و سازمان‌های ثبت‌شده) است. خطوط به‌صورت پیش‌فرض یک‌طرفه (فقط دریافت تماس) هستند و امکان تبدیل به دوطرفه با افزودن سه رقم صفر و درخواست و تأیید جداگانه از مخابرات وجود دارد.",
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "areaServed": {
        "@type": "City",
        "name": "تهران",
        "sameAs": "https://www.wikidata.org/wiki/Q3616"
      },
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "اشخاص حقوقی (شرکت‌ها و سازمان‌های ثبت‌شده) - بدون امکان ثبت برای اشخاص حقیقی"
      },
      "url": "https://navatel.ir/products/5-digit-line/",
      "brand": {
        "@id": "https://navatel.ir/#organization"
      },
      "offers": {
        "@type": "Offer",
        "url": "https://navatel.ir/products/5-digit-line/",
        "availability": "https://schema.org/InStock",
        "priceSpecification": {
          "@type": "PriceSpecification",
          "description": "قیمت خط ۵ رقمی بر اساس شماره انتخابی متغیر است و نیازمند استعلام از کارشناسان نواتل می‌باشد؛ نسبت به خط ۴ رقمی مقرون‌به‌صرفه‌تر است."
        }
      },
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "مدرک ۱ - کارت ملی",
          "value": "تصویر پشت و رو کارت ملی صاحبین امضای مجاز"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۲ - شناسنامه",
          "value": "تصویر صفحه اول و صفحه تغییرات شناسنامه صاحبین امضای مجاز"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۳ - آگهی تاسیس",
          "value": "تصویر آگهی تاسیس شرکت"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۴ - روزنامه رسمی",
          "value": "تصویر روزنامه رسمی شرکت شامل آخرین تغییرات"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۵ - سند محل",
          "value": "سند مالکیت یا اجاره‌نامه شرکت"
        },
        {
          "@type": "PropertyValue",
          "name": "نوع خط",
          "value": "پیش‌فرض یک‌طرفه؛ قابل تبدیل به دوطرفه با تأیید مخابرات"
        },
        {
          "@type": "PropertyValue",
          "name": "زمان تحویل",
          "value": "فوری، حتی در ایام تعطیل"
        }
      ]
    },
    {
      "@type": "HowTo",
      "@id": "https://navatel.ir/products/5-digit-line/#howto",
      "name": "مراحل دریافت خط ۵ رقمی از نواتل",
      "description": "فرآیند چهار مرحله‌ای دریافت خط تلفن ۵ رقمی مخابرات از نواتل، از مشاوره اولیه تا تحویل و فعال‌سازی خط.",
      "about": {
        "@id": "https://navatel.ir/products/5-digit-line/#service"
      },
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "مشاوره و انتخاب شماره",
          "text": "برای بررسی شماره‌های موجود، با کارشناسان نواتل تماس بگیرید."
        },
        {
          "@type": "HowToStep",
          "position": 2,
          "name": "ارسال مدارک",
          "text": "مدارک حقوقی شرکت را به همراه نامه‌ی درخواست خط، به مخابرات ارسال کنید."
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "بررسی و تأیید مخابرات",
          "text": "مدارک توسط مخابرات بررسی و تأیید می‌شود."
        },
        {
          "@type": "HowToStep",
          "position": 4,
          "name": "تحویل و فعال‌سازی",
          "text": "خط فعال شده و آماده استفاده تحویل داده می‌شود."
        }
      ]
    }
  ]
}